import { Modal, Popover, Tooltip, Spin } from 'antd';
import {
  LoadingOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from '@ant-design/icons';
import React, { useEffect, useState, useRef } from 'react';
import './appLayout.css';

//custom-svg
import Channels from '../../assets/customSVG/navChannels';
import CRM from '../../assets/customSVG/sideNav/CRM';
import Calendar from '../../assets/customSVG/sideNav/Calendar';
import Campaigns from '../../assets/customSVG/sideNav/Campaigns';
import Chevron from '../../assets/customSVG/sideNav/Chevron';
import Home from '../../assets/customSVG/sideNav/Home';
import UnifiedInbox from '../../assets/customSVG/sideNav/UnifiedInbox';
import Webchat from '../../assets/customSVG/sideNav/Webchat';
import DocumentLoader from '../../assets/customSVG/sideNav/DocumentLoader';
import UpgradeIcon from '../../assets/customSVG/UpgradeIcon';
import BranchIcon from '../../assets/customSVG/BranchIcon';

//icons
import { ICONS } from '../../assets/icons';
import { ICONSS } from '../../assets/icons/index1';

//helper
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAspDispatch, useAspSelector } from '../../test/jest-redux-hooks';

//redux
import { setPageNavigate } from '../../reduxToolkit/CampaignSlice';
import {
  reset_feature_flag,
  setExpand,
  setUpdateAccount,
  updateCurrentUser,
  updateToggleToast,
} from '../../reduxToolkit/appSlice';

//api
import { draftApi } from '../../modules/campaign/api/Api';
import {
  carouselDiscard,
  templateDiscard,
} from '../../modules/channels/api/Api';

//common-components
import HeaderDropDown from '../../components/commonComponents/HeaderDropDown/HeaderDropDown';
import NewAlert from '../../components/commonComponents/modal/alert/NewAlert';

// constant
import {
  creditsApi,
  currentUserDetails,
  Logout,
  markRecentAccountActive,
  markRecentActive,
} from '../../api/Api';
import AccountOverview from '../../assets/customSVG/accounts/AccountOverview';
import Purchases from '../../assets/customSVG/accounts/Purchases';
import Teams from '../../assets/customSVG/accounts/Teams';
import { myProfile } from '../../constant/app/account/account';
import {
  accountNavigation,
  navigationConst,
} from '../../constant/app/appLayout';
import { inputsArray } from '../../modules/accounts/constants/home';
import useToggle from '../../hooks/useToggle';
import IntegrationIcon from '../../assets/customSVG/IntegrationIcon';
import SettingsIcon from '../../assets/customSVG/channels/SettingsIcon';
import Loader from '../../components/commonComponents/Loader/Index';
import AgentConfig from '../../assets/customSVG/sideNav/AgentConfig';
import Popup from '../../assets/customSVG/accounts/Popup';
import CheckoutModal from '../../modules/accounts/components/CheckoutModal';
import PricingPlanModal from '../../modules/accounts/components/PricingPlanModal';
import { useRazorpay } from 'react-razorpay';
import {
  creditsSendApi,
  transactionsApi,
  transactionsResponseApi,
  brandUserEditApi,
  brandsInfoApi,
} from '../../modules/accounts/api/Api';
import { cityListApi, stateListApi } from '../../modules/crm/api/Api';
import { category } from '../../modules/auth/components/onboarding/BrandCreation';
import { isValidGST, numberOnly } from '../../helper/validation';
import { validateURL } from '../../helper/checkUrls';
import { razorpay_key } from '../../api/ApiConfig';
import dayjs from 'dayjs';

const iconComponents = {
  Home: Home,
  Campaigns: Campaigns,
  Broadcasts: Campaigns, // Reuse Campaigns icon for now
  Sequences: BranchIcon,
  Calendar: Calendar,
  CRM: CRM,
  Inbox: UnifiedInbox,
  Channels: Channels,
  Webchat: Webchat,
  DataSources: DocumentLoader,
  // Agents: Calendar,
  Integrations: IntegrationIcon,
  Settings: SettingsIcon,
  'Account Info': Home,
  'Account Users': Teams,
  Brands: AccountOverview,
  Products: Purchases,
  Agents: AgentConfig,
};

const selectedIcons = {
  // Home: ICONSS?.homeSelected,
  Campaigns: ICONSS?.campaignSelected,
  Calendar: ICONSS?.calendarSelected,
  CRM: ICONSS?.crmSelected,
  Inbox: ICONSS?.inboxSelected,
  Channels: ICONSS?.channelSelected,
  'Google Calendar': ICONSS?.settingSelected,
};

function SideBar() {
  //redux
  const templateDetails = useAspSelector((state) => state?.Template);
  const {
    currentBrand,
    toggleToast,
    currentUser,
    currentAccount,
    expand,
    featureFlags,
  } = useAspSelector((state) => state?.app);
  const { saveBroadcastDatas } = useAspSelector((state) => state.broadcast);

  // get billing plan name
  const billing_plan_name = currentBrand?.brand_billing_plan_name;

  //react-redux
  const dispatch = useAspDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const location = useLocation();

  const [hoveredNav, setHoveredNav] = useState(null);

  //modals && popover
  const [discardAlertOpen, setDiscardAlertOpen] = useState(false);
  const [draftAlertOpen, setDraftAlertOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPlansVisible, setIsPlansVisible] = useState(false);
  const [isPopover, setIsPopover] = useState(false);
  const [loader, setLoader] = useToggle(false);
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);

  // Scroll logic for nav list
  const navScrollRef = useRef(null);
  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(false);

  const checkScroll = () => {
    const el = navScrollRef.current;
    if (el) {
      setCanScrollUp(el.scrollTop > 5);
      setCanScrollDown(el.scrollHeight - el.scrollTop - el.clientHeight > 5);
    }
  };

  useEffect(() => {
    const el = navScrollRef.current;
    if (el) {
      el.addEventListener('scroll', checkScroll);
      // Initial check
      checkScroll();

      // Check on window resize
      window.addEventListener('resize', checkScroll);

      // Mutation observer to check when nav list items change (e.g. features flags)
      const observer = new MutationObserver(checkScroll);
      observer.observe(el, { childList: true, subtree: true });

      return () => {
        el.removeEventListener('scroll', checkScroll);
        window.removeEventListener('resize', checkScroll);
        observer.disconnect();
      };
    }
  }, []);

  // Check scroll when expand state changes
  useEffect(() => {
    setTimeout(checkScroll, 300); // Wait for transition
  }, [expand]);

  const handleArrowScroll = (direction) => {
    const el = navScrollRef.current;
    if (el) {
      const scrollAmount = direction === 'up' ? -150 : 150;
      el.scrollBy({ top: scrollAmount, behavior: 'smooth' });
    }
  };

  const [subscriptionExpiredPopover, setSubscriptionExpiredPopover] =
    useState(false);

  // credits and plan details
  const [credits, setCredits] = useState([]);
  const [planDetails, setPlanDetails] = useState(null);

  // Store the intended navigation path when showing draft alert
  const [intendedPath, setIntendedPath] = useState(null);

  // Buy Credits Modal State
  const [addCredits, setAddCredits] = useState(false);
  const [creditValue, setCreditValue] = useState(null);
  const [closeHover, setCloseHover] = useState(false);

  // Payment Modal State
  const [proceed, setProceed] = useState(false);
  const [brandsData, setBrandsData] = useState({});
  const [creditsResponse, setCreditsResponse] = useState(null);
  const [dynamicInputs, setDynamicInputs] = useState([]);
  const [editInfo, setEditInfo] = useState(false);
  const [locationError, setLocationError] = useState('');
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [isPlanSelected, setIsPlanSelected] = useState(false);
  const { Razorpay } = useRazorpay();

  // Helper variables for modal
  const input =
    'w-full font14px-500 border border-[var(--border-input)] rounded-lg px-3 py-2 outline-none focus:border-[var(--new-primary)]';
  const inputContainer =
    'w-full flex items-center gap-2 py-2 px-3 border border-[var(--border-input)] b-radius-6';

  const buttonClass = () => {
    return 'bg-[var(--new-primary)] text-white font14px-500 rounded-md'; // Simplified for sidebar
  };

  const buttonEnable = () => {
    if (!dynamicInputs || dynamicInputs.length === 0) return false;

    return dynamicInputs.every((input) => {
      // GST field (id 10) - validate if entered for INR currency
      if (input?.id === 10) {
        if (!input?.value) return true; // empty is allowed
        return isValidGST(input?.value); // must be valid if entered
      }

      // City field (id 8) - optional
      if (input?.id === 8) {
        return true;
      }

      // Check if field has value
      const isValid =
        input?.value &&
        input?.value !== undefined &&
        input?.value !== null &&
        input?.value !== 'Unknown';

      // Brand Name validation (id 1)
      if (input?.label === 'Brand Name') {
        return (
          isValid &&
          !input?.value.endsWith("'") &&
          !input?.value.endsWith('-') &&
          !input?.value.endsWith('.')
        );
      }

      // Website URL validation (id 4 or label "Website URL")
      if (input?.id === 4 || input?.label === 'Website URL') {
        return validateURL(input?.value);
      }

      // Postal code validation (id 9)
      if (input?.id === 9) {
        return isValid && input.value?.length >= 5;
      }

      return isValid;
    });
  };

  const updateData = ({ datas, value }) => {
    if (!value) return datas;
    const res = datas?.map((data) => {
      const { key, secondaryKey } = data;
      if (secondaryKey) {
        const data_id =
          secondaryKey === 'country'
            ? value?.[key]?.[0]?.['country_id']
            : secondaryKey === 'city'
            ? value?.[key]?.[0]?.['city_id']
            : secondaryKey === 'province'
            ? value?.[key]?.[0]?.['province_id']
            : '';
        return {
          ...data,
          value: value?.[key]?.[0]?.[secondaryKey],
          locations_id: data_id,
        };
      }
      return { ...data, value: value?.[key] };
    });
    return res;
  };

  useEffect(() => {
    if (currentBrand && Object.keys(currentBrand).length > 0) {
      setBrandsData(currentBrand);
    }
  }, [currentBrand]);

  // Fetch full brand info when Buy Credits modal opens
  useEffect(() => {
    if (addCredits && currentBrand?.brand_id) {
      brandsInfoApi(currentBrand.brand_id).then((res) => {
        if (res?.status === 200) {
          const fullBrandData =
            res?.data?.data?.[0] || res?.data?.data || res?.data;
          setBrandsData(fullBrandData);
        }
      });
    }
  }, [addCredits, currentBrand?.brand_id]);

  useEffect(() => {
    if (brandsData && Object.keys(brandsData).length > 0) {
      setDynamicInputs(updateData({ datas: inputsArray, value: brandsData }));

      const location = brandsData.locations_with_names?.[0];
      if (location?.country_id) {
        stateListApi(location.country_id).then((res) => {
          if (res?.status === 200) {
            const states = res?.data?.data?.map((item) => ({
              label: item?.name,
              value: item?.name,
              id: item?.id,
            }));
            setStateList(states);
          }
        });
      }
      if (location?.province_id) {
        cityListApi(location.province_id).then((res) => {
          if (res?.status === 200) {
            const cities = res?.data?.data?.map((item) => ({
              label: item?.name,
              value: item?.name,
              id: item?.id,
            }));
            setCityList(cities);
          }
        });
      }
    }
  }, [brandsData]);

  const handleBrandChange = ({ id, value, locations_id }) => {
    if (id === 9) {
      // GST Logic
      if (value.length <= 15) {
        setDynamicInputs((prev) =>
          prev.map((item) =>
            item.id === id ? { ...item, value: value.toUpperCase() } : item,
          ),
        );
      }
    } else {
      setDynamicInputs((prev) => {
        const updated = prev.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              value: value,
              locations_id: locations_id || item.locations_id,
            };
          }
          return item;
        });

        if (id === 7) {
          // State change: fetch new cities and reset city field
          setCityList([]);
          if (locations_id) {
            cityListApi(locations_id).then((res) => {
              if (res?.status === 200) {
                const cities = res?.data?.data?.map((item) => ({
                  label: item?.name,
                  value: item?.name,
                  id: item?.id,
                }));
                setCityList(cities);
              }
            });
          }
          return updated.map((item) =>
            item.id === 8 ? { ...item, value: '', locations_id: null } : item,
          );
        }

        return updated;
      });
    }
  };

  const handleUpdate = () => {
    // Update logic matching BrandOverview exactly
    const payLoad = {
      brand_name: dynamicInputs?.[0]?.value,
      website_url: dynamicInputs?.[2]?.value,
      category: dynamicInputs?.[1]?.value,
      gst_number: dynamicInputs?.[8]?.value,
      address: {
        id: brandsData?.locations_with_names?.[0]?.location,
        address_line_1: dynamicInputs?.[3]?.value,
        country_id: dynamicInputs?.[4]?.locations_id,
        province_id: dynamicInputs?.[5]?.locations_id,
        city_id: dynamicInputs?.[6]?.locations_id || 1,
        postal_index_code: dynamicInputs?.[7]?.value,
      },
    };

    if (buttonEnable()) {
      setLoader(true);
      brandUserEditApi(currentBrand?.brand_id, payLoad).then((res) => {
        if (res?.status === 200) {
          dispatch(
            updateToggleToast([
              ...toggleToast,
              {
                id: toggleToast?.length + 1,
                content: 'Brand Information Updated',
                status: 'Success',
                duration: '',
              },
            ]),
          );
          setEditInfo(false);
          setLoader(false);
          // Re-fetch brand info to update the form
          brandsInfoApi(currentBrand?.brand_id).then((res) => {
            if (res?.status === 200) {
              const fullBrandData =
                res?.data?.data?.[0] || res?.data?.data || res?.data;
              setBrandsData(fullBrandData);
              setDynamicInputs(
                updateData({ datas: inputsArray, value: fullBrandData }),
              );
            }
          });
        } else {
          setLoader(false);
        }
      });
    }
  };

  const handleRenewSubscription = () => {
    setLoader(true);
    const payLoad = {
      brand_id: currentBrand?.brand_id,
      transaction_type: 'SUBSCRIPTION',
      billing_plan_name: billing_plan_name
        ? billing_plan_name
        : 'Starter Plan India',
      billing_cycle: currentBrand?.billing_cycle
        ? currentBrand?.billing_cycle.toLowerCase()
        : 'monthly',
    };

    creditsSendApi(payLoad)
      .then((res) => {
        if (res?.status === 200) {
          setCreditsResponse(res?.data?.credit_item);
          // Fetch full brand info to ensure all fields (address, etc.) are available for inputsArray
          brandsInfoApi(currentBrand?.brand_id)
            .then((brandRes) => {
              if (brandRes?.status === 200) {
                // Ensure we get the correct data object.
                // Based on typical patterns, it might be brandRes.data.data or brandRes.data
                const fullBrandData =
                  brandRes?.data?.data?.[0] ||
                  brandRes?.data?.data ||
                  brandRes?.data;

                setBrandsData(fullBrandData);
                setDynamicInputs(
                  updateData({ datas: inputsArray, value: fullBrandData }),
                );
                setEditInfo(false); // Reset edit mode when opening modal
                setProceed(true);
                setSubscriptionExpiredPopover(false);

                // Fetch states/cities if needed based on initial data
                const location = fullBrandData?.locations_with_names?.[0];
                if (location?.province_id) {
                  // Fetch states for the country
                  stateListApi(location?.country_id).then((res) => {
                    if (res?.status === 200) {
                      const states = res?.data?.data?.map((item) => ({
                        label: item?.name,
                        value: item?.name,
                        id: item?.id,
                      }));
                      setStateList(states);
                    }
                  });

                  // Fetch cities for the state
                  cityListApi(location?.province_id).then((res) => {
                    if (res?.status === 200) {
                      const cities = res?.data?.data?.map((item) => ({
                        label: item?.name,
                        value: item?.name,
                        id: item?.id,
                      }));
                      setCityList(cities);
                    }
                  });
                }
              } else {
                // Fallback
                const fallbackData = res?.data?.brand || currentBrand;
                setBrandsData(fallbackData);
                setDynamicInputs(
                  updateData({ datas: inputsArray, value: fallbackData }),
                );
                setEditInfo(false); // Reset edit mode
                setProceed(true);
                setSubscriptionExpiredPopover(false);
              }
            })
            .catch(() => {
              // Fallback on error
              const fallbackData = res?.data?.brand || currentBrand;
              setBrandsData(fallbackData);
              setDynamicInputs(
                updateData({ datas: inputsArray, value: fallbackData }),
              );
              setEditInfo(false); // Reset edit mode
              setProceed(true);
              setSubscriptionExpiredPopover(false);
            })
            .finally(() => {
              setLoader(false);
            });
        } else {
          setLoader(false);
          dispatch(
            updateToggleToast([
              ...toggleToast,
              {
                id: toggleToast?.length + 1,
                content:
                  res?.response?.data?.error || 'Error initializing renewal',
                status: 'Error',
                duration: '',
              },
            ]),
          );
        }
      })
      .catch((err) => {
        setLoader(false);
        console.error('Renewal error:', err);
      });
  };

  const handlePayment = (updatedBillSummary, selectedBillingCycle) => {
    setLoader(true);

    // Use the updated bill summary if available (from billing cycle change), otherwise use original creditsResponse
    const billData = updatedBillSummary || creditsResponse;
    const transactionItemId = billData?.credit_item?.id || billData?.id;

    const payLoad = {
      brand_id: currentBrand?.brand_id,
      transaction_item_id: transactionItemId,
      type: isPlanSelected ? 'SUBSCRIPTIONS' : 'CREDITS',
    };

    transactionsApi(payLoad).then((res) => {
      if (res?.status === 200) {
        setLoader(false);
        setProceed(false);
        const options = {
          key: razorpay_key,
          amount: res?.data?.transaction?.total_cost * 100,
          currency: res?.data?.transaction?.currency,
          order_id: res?.data?.transaction?.razerpay_order_id,
          notes: {
            transaction_id: transactionItemId,
          },
          handler: (response) => {
            transactionsResponseApi(response).then((res) => {
              if (res?.status === 200) {
                setLoader(false);
                setAddCredits(false);
                setCreditValue(null);
                setIsPlanSelected(false);
                dispatch(
                  updateToggleToast([
                    ...toggleToast,
                    {
                      id: toggleToast?.length + 1,
                      content: 'Payment Success',
                      status: 'Success',
                      duration: '',
                    },
                  ]),
                );

                // Refresh credits display
                creditsApi(currentBrand?.brand_id).then((res) => {
                  if (res?.status === 200) {
                    setCredits(res?.data?.brand_credits);
                    setPlanDetails(res?.data?.plan_details);
                  }
                });

                // Reload for subscription renewals
                if (isPlanSelected) {
                  window.location.reload();
                }
              } else {
                setLoader(false);
              }
            });
          },
        };
        const rzp1 = new Razorpay(options);
        rzp1.on('payment.failed', function (response) {
          dispatch(
            updateToggleToast([
              ...toggleToast,
              {
                id: toggleToast?.length + 1,
                content: response.error.description,
                status: 'Error',
                duration: '',
              },
            ]),
          );
        });
        rzp1.open();
      } else {
        setLoader(false);
      }
    });
  };

  const handleCreditClick = (item) => {
    if (parseFloat(creditValue || 0) >= 100000) {
      return;
    }

    // Extract the numeric value from the item label (e.g., '10.00' from '+ 10.00')
    const amount = item.label.replace(/[^\d.]/g, '');
    const numericValue = parseFloat(amount) || 0;

    const updatedValue = parseFloat(creditValue || 0) + numericValue;

    if (updatedValue > brandsData?.maximum_credits) {
      setCreditValue(brandsData?.maximum_credits);
    } else {
      setCreditValue(updatedValue);
    }
  };

  const handleCreditValue = (e) => {
    let val = numberOnly(e.target.value, true);

    const parts = val.split('.');
    if (parts.length > 1 && parts[1].length > 2) {
      val = parts[0] + '.' + parts[1].slice(0, 2);
    }

    if (val < 0 || val > brandsData?.maximum_credits) {
      return;
    }

    setCreditValue(val);
  };

  const handleCreditSend = () => {
    setLoader(true);
    const payLoad = {
      brand_id: currentBrand?.brand_id,
      amount: parseFloat(creditValue),
      transaction_type: 'CREDITS',
    };

    creditsSendApi(payLoad).then((res) => {
      if (res?.status === 200) {
        setLoader(false);
        setCreditsResponse(res?.data?.credit_item);
        setIsPlanSelected(false);

        // Fetch full brand info for checkout modal
        brandsInfoApi(currentBrand?.brand_id).then((brandRes) => {
          if (brandRes?.status === 200) {
            const fullBrandData =
              brandRes?.data?.data?.[0] ||
              brandRes?.data?.data ||
              brandRes?.data;
            setBrandsData(fullBrandData);
            setDynamicInputs(
              updateData({ datas: inputsArray, value: fullBrandData }),
            );
            setEditInfo(false);
            setProceed(true);
            setAddCredits(false);

            // Fetch states/cities if needed
            const location = fullBrandData?.locations_with_names?.[0];
            if (location?.province_id) {
              stateListApi(location?.country_id).then((res) => {
                if (res?.status === 200) {
                  const states = res?.data?.data?.map((item) => ({
                    label: item?.name,
                    value: item?.name,
                    id: item?.id,
                  }));
                  setStateList(states);
                }
              });

              cityListApi(location?.province_id).then((res) => {
                if (res?.status === 200) {
                  const cities = res?.data?.data?.map((item) => ({
                    label: item?.name,
                    value: item?.name,
                    id: item?.id,
                  }));
                  setCityList(cities);
                }
              });
            }
          }
        });
      } else {
        setLoader(false);
        setLocationError(res?.response?.data?.error);
      }
    });
  };

  const matchingBrandStatuses = currentBrand?.brand_status;

  useEffect(() => {
    if (
      matchingBrandStatuses &&
      matchingBrandStatuses == 9 &&
      location?.pathname?.startsWith('/user')
    ) {
      setSubscriptionExpiredPopover(true);
    } else {
      // Hide popup when navigating to account center or other non-brand pages
      setSubscriptionExpiredPopover(false);
    }
  }, [matchingBrandStatuses, location]);

  const { id } = useParams();
  const header = id;

  const navigationPath =
    pathname !== '/profile' ? navigationConst : accountNavigation;
  const [navList, setNavList] = useState(navigationPath);
  const [openSubNav, setOpenSubNav] = useState(null);

  const handleExpand = () => {
    dispatch(setExpand(!expand));
  };

  //modals-popover functions
  const handleCancel = () => {
    setIsModalVisible(false);
    setIsPlansVisible(false);
  };

  const handleYes = () => {
    setLoader(true);

    Logout().then((res) => {
      dispatch(reset_feature_flag());
      if (res?.status === 200) {
        navigate('/login');
        dispatch(setExpand(false));
        localStorage.clear();
      } else {
        console.warn('error', res);
      }
    });
  };

  const handleItemClick = () => {
    setIsModalVisible(true);
    setIsPopover(false);
  };

  const handleVisibleChange = () => {
    setIsPlansVisible(!isPlansVisible);
  };

  const discardCarousel = () => {
    if (
      location.pathname ===
        '/user/channels/whatsapp/edit-template/template-details' &&
      templateDetails?.categoryType === 'CAROUSEL'
    ) {
      const payLoad = {
        brand_id: currentBrand?.brand_id,
      };

      carouselDiscard(templateDetails?.id, payLoad).then((res) => {
        if (res?.status === 200) {
          setDiscardAlertOpen(false);
          navigate('/user/channels/whatsapp/message-templates');
        }
      });
    } else if (
      location.pathname ===
        '/user/channels/whatsapp/edit-template/template-details' &&
      templateDetails?.categoryType !== 'CAROUSEL'
    ) {
      const payLoad = {
        brand_id: currentBrand?.brand_id,
      };

      templateDiscard(templateDetails?.id, payLoad).then((res) => {
        if (res?.status === 200) {
          setDiscardAlertOpen(false);
          navigate('/user/channels/whatsapp/message-templates');
        }
      });
    } else {
      if (saveBroadcastDatas?.broadcast_id !== null) {
        draftApi(saveBroadcastDatas).then((createCampaignResponse) => {
          if (createCampaignResponse?.status === 200) {
            dispatch(
              updateToggleToast([
                ...toggleToast,
                {
                  id: toggleToast?.length + 1,
                  content: 'Broadcast saved successfully',
                  status: 'Success',
                  duration: '',
                },
              ]),
            );
            setDraftAlertOpen(false);
            // Navigate to the intended path if it exists, otherwise default to campaigns
            if (intendedPath) {
              navigate(intendedPath);
              setIntendedPath(null);
            } else {
              navigate('/user/campaign/all');
            }
          } else {
            setDraftAlertOpen(false);

            dispatch(
              updateToggleToast([
                ...toggleToast,
                {
                  id: toggleToast?.length + 1,
                  content:
                    createCampaignResponse?.response?.data?.error ||
                    'Unable to save Broadcast',
                  status: 'Error',
                  duration: '',
                },
              ]),
            );
          }
        });
      }
    }
  };

  //modules navigate functions
  useEffect(() => {
    if (pathname.startsWith('/profile')) {
      if (
        currentAccount?.role === 'Account User' ||
        currentAccount?.role === 'Brand Manager' ||
        currentAccount?.role === 'Campaign Manager'
      ) {
        const filteredNavList = accountNavigation.filter(
          (item) => item.id !== 2 && item.id !== 3,
        );
        setNavList(filteredNavList);
      } else {
        setNavList(accountNavigation);
      }
    } else {
      setNavList(navigationConst);
    }

    updateNavListState(pathname);
  }, [pathname, currentBrand]);

  const navigateModule = (item) => {
    dispatch(setUpdateAccount(false));

    if (location.pathname.startsWith('/user')) {
      creditsApi(currentBrand?.brand_id).then((res) => {
        if (res?.status === 200) {
          setCredits(res?.data?.brand_credits);
          setPlanDetails(res?.data?.plan_details);
        }
      });
    }

    // if (currentBrand && currentBrand?.is_whatsapp_connected) {
    if (
      location.pathname !==
        '/user/channels/whatsapp/edit-template/template-details' &&
      location.pathname !== `/user/campaign/time_specified/settings/${header}`
    ) {
      updateNavListState(item?.routeUrl);
      item?.navName === 'Channels'
        ? navigate('/user/channels/whatsapp')
        : item?.navName === 'Home'
        ? navigate('/user/home')
        : navigate(`.${item?.routeUrl}`);
    } else if (
      location.pathname ===
        '/user/channels/whatsapp/edit-template/template-details' &&
      (templateDetails?.details?.status === 'PAM' ||
        templateDetails?.details?.status === 'APPROVED' ||
        templateDetails?.details?.status === 'REJECTED' ||
        templateDetails?.details?.status === 'PRM')
    ) {
      setDiscardAlertOpen(true);
    } else if (
      location.pathname ===
        `/user/campaign/time_specified/settings/${header}` &&
      saveBroadcastDatas?.broadcast_id !== null
    ) {
      // Store the intended navigation path before showing the draft alert
      const targetPath =
        item?.navName === 'Channels'
          ? '/user/channels/whatsapp'
          : item?.navName === 'Home'
          ? '/user/home'
          : item?.routeUrl;
      setIntendedPath(targetPath);
      setDraftAlertOpen(true);
    } else {
      updateNavListState(item?.routeUrl);
      item?.navName === 'Channels'
        ? navigate('/user/channels/whatsapp')
        : item?.navName === 'Home'
        ? navigate('/user/home')
        : navigate(`.${item?.routeUrl}`);
    }

    if (location.pathname.startsWith('/user')) {
      markRecentActive(currentBrand?.brand_id, currentAccount?.account_id);
      markRecentAccountActive(currentAccount?.account_id);
    } else {
      markRecentAccountActive(currentAccount?.account_id);
    }

    // account last active api

    // }
  };
  const updateNavListState = (path) => {
    if (location.pathname.startsWith('/user')) {
      creditsApi(currentBrand?.brand_id).then((res) => {
        if (res?.status === 200) {
          setCredits(res?.data?.brand_credits);
          setPlanDetails(res?.data?.plan_details);
        }
      });
    }

    setNavList((prev) =>
      prev.map((item) => {
        // --- handle sub‑nav first ------------------------------------------
        const newSubNav = item.subNav?.map((sub) => {
          const subSelected = path.includes(sub.routeUrl);
          return { ...sub, selected: subSelected };
        });

        // Did *any* sub‑item match?
        const anySubSelected = newSubNav?.some((s) => s.selected);

        // --- handle top‑level item -----------------------------------------
        const isCampaigns =
          item.navName === 'Campaigns' &&
          (path.startsWith('/user/campaign') ||
            path.startsWith('/user/api') ||
            path.startsWith('/user/ContactApi'));

        const topSelected =
          anySubSelected || // Inbox case
          path.includes(item.routeUrl ?? '__NO_ROUTE__') || // normal top‑level
          isCampaigns; // special campaigns

        return {
          ...item,
          selected: topSelected,
          subNav: newSubNav ?? item.subNav, // keep it if none
        };
      }),
    );
  };

  useEffect(() => {
    if (location.pathname.startsWith('/user')) {
      creditsApi(currentBrand?.brand_id).then((res) => {
        if (res?.status === 200) {
          setCredits(res?.data?.brand_credits);
          setPlanDetails(res?.data?.plan_details);
        }
      });
    }
  }, [location]);

  const formatNumber = (num) => {
    if (num >= 1_000_000) {
      return `${(num / 1_000_000).toFixed(2)}M`;
    } else if (num >= 1000) {
      return `${(num / 1000).toFixed(2)}K`;
    } else {
      return num.toString();
    }
  };

  // Get plan info from API response
  const getPlanInfo = () => {
    if (!planDetails) return null;

    return {
      type: planDetails.is_trial ? 'trial' : 'subscription',
      daysLeft: planDetails.days_left || 0,
      expiryDate: planDetails.end_date
        ? dayjs(planDetails.end_date).format('MMM DD, YYYY')
        : 'N/A',
      isExpired: planDetails.days_left <= 0 || planDetails.status === 9,
      planName: planDetails.plan_name || 'Free Trial',
      planCode: planDetails.plan_code || 'free',
    };
  };

  // Format plan name
  const getPlanDisplayName = () => {
    if (!planDetails) return 'Free Trial';

    const planName = planDetails.plan_name;
    if (!planName) return 'Free Trial';

    return (
      planDetails.plan_code?.charAt(0)?.toUpperCase() +
      planDetails?.plan_code?.slice(1)
    );
  };

  return (
    <nav
      className={`side_bar_container flex flex-col justify-between py-4 ${
        expand
          ? 'nav-open border border-[#F1F4F6]'
          : 'nav-close border border-[#F1F4F6]'
      }`}
      style={{
        height: '100vh',
        overflow: 'hidden',
        position: 'relative',
        zIndex: subscriptionExpiredPopover ? 1050 : 'auto',
      }}
    >
      <div className="flex flex-col flex-1 min-h-0">
        <div
          className={`w-100 flex-row align-center mr-5  ${
            expand ? 'space-between' : ' translate-x-1 '
          }`}
        >
          {expand ? (
            <img src={ICONS?.logoGain} alt="logoGain" />
          ) : (
            <img src={ICONS?.logoMinimize} alt="logoMinimize" className="" />
          )}
          <span
            onClick={handleExpand}
            className={`pointer    ${
              expand ? 'ml-5' : 'ml-[10px] rotate-180 translate-x-2 '
            }`}
          >
            <img src={ICONS?.sideNavExpand} alt="sideNavExpand" />
          </span>
        </div>
        {(pathname.includes('/user') || pathname.includes('/profile')) && (
          <div className="header-line ptb-5 mt-20">
            <HeaderDropDown expand={expand} />
          </div>
        )}
        {/* Scrollable Navigation List */}
        <div className="flex-1 min-h-0 relative flex flex-col group/nav">
          {canScrollUp && (
            <div
              className="absolute top-0 left-0 right-0 z-[11] flex items-center justify-center cursor-pointer py-1 transition-all duration-300 hover:opacity-100 opacity-70"
              style={{
                background:
                  'linear-gradient(to bottom, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.4) 60%, transparent 100%)',
                color: '#616874',
              }}
              onClick={() => handleArrowScroll('up')}
            >
              <ArrowUpOutlined className="text-sm" />
            </div>
          )}

          <div
            ref={navScrollRef}
            className={`${
              expand ? ' ' : 'pl-[3px]'
            } overflow-y-auto flex-1 min-h-0 no-scrollbar`}
            style={{
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {navList?.map((item) => {
              switch (item.navName) {
                case 'Campaigns':
                  // Hide Campaigns when standalone mode is enabled
                  if (featureFlags?.standalone_broadcasts_sequences_feature) {
                    return;
                  }
                  break;
                case 'Broadcasts':
                case 'Sequences':
                  // Show Broadcasts/Sequences only when standalone mode is enabled
                  if (!featureFlags?.standalone_broadcasts_sequences_feature) {
                    return;
                  }
                  break;
                case 'Webchat':
                  if (!featureFlags?.webchat_feature) {
                    return;
                  }
                  break;
                case 'Agents':
                  if (!featureFlags?.rag_whatsapp_chat_system) {
                    return;
                  }
                  break;
                case 'Products':
                  if (
                    !featureFlags?.whatsapp_payment_feature ||
                    !billing_plan_name?.toLowerCase()?.endsWith('india')
                  ) {
                    return;
                  }
                  break;
              }
              return (
                <div
                  key={item?.id}
                  className={`navBox mt-20 ${
                    item?.selected ? 'active-listText1' : ''
                  }`}
                  onMouseEnter={() => setHoveredNav(item?.navName)}
                  onMouseLeave={() => setHoveredNav(null)}
                  onClick={() => {
                    navigateModule(item);
                    if (item?.navName === 'Campaigns') {
                      dispatch(setPageNavigate('All Campaigns'));
                    }
                  }}
                >
                  <Tooltip title={!expand ? `${item?.navName}` : ''}>
                    {(() => {
                      const IconComponent = iconComponents[item?.navName];
                      const selectedIcon = selectedIcons[item?.navName];

                      const color = item?.selected
                        ? 'white'
                        : hoveredNav === item?.navName
                        ? 'var(--textBlack)'
                        : '#616874';

                      const fillColors = item?.selected ? 'white' : 'none';
                      if (selectedIcon && item?.selected) {
                        return <img src={selectedIcon} alt="" />;
                      }

                      if (IconComponent) {
                        return (
                          <IconComponent
                            color={color}
                            lineColor={color}
                            fillColor={color}
                            fillColors={fillColors}
                            width={
                              item?.navName === 'Channels' ? '24' : undefined
                            }
                            height={
                              item?.navName === 'Channels' ? '24' : undefined
                            }
                          />
                        );
                      }
                      return null;
                    })()}
                  </Tooltip>

                  <div
                    className={`navName pl-10 ${
                      expand ? 'expand-block' : 'expand-hidden'
                    }`}
                    onMouseEnter={() => setHoveredNav(item?.navName)}
                    onMouseLeave={() => setHoveredNav(null)}
                    onClick={() => {
                      // if (item?.navName === "Inbox") {
                      //   setOpenSubNav(openSubNav === item?.id ? null : item?.id);
                      // } else {
                      navigateModule(item);
                      // }
                      if (item?.navName === 'Campaigns') {
                        dispatch(setPageNavigate('All Campaigns'));
                      }
                    }}
                  >
                    <div className="w-100 navName pl-10 flex-row align-center justify-between">
                      <span
                        className={` ${
                          expand ? 'expand-block' : 'expand-hidden'
                        }`}
                      >
                        {item?.navName}
                      </span>
                    </div>
                  </div>
                  {openSubNav === item?.id && (
                    <div className="flex-column align-center mr-10 ">
                      {item?.subNav?.map((subItem) => {
                        return (
                          <div
                            key={subItem?.id}
                            className={`navBox ml-20 pointer1 ${
                              subItem?.selected
                                ? 'active-listText1'
                                : '!text-[var(--font-600)] !font-[400] '
                            }`}
                            onMouseEnter={() => setHoveredNav(subItem?.navName)}
                            onMouseLeave={() => setHoveredNav(null)}
                            onClick={() => {
                              navigateModule(subItem);
                            }}
                          >
                            <div className="navName  mrl-20 flex-row align-center gap-2 ">
                              {subItem?.icon ? (
                                <img
                                  src={subItem?.icon}
                                  alt=""
                                  className="w-4"
                                />
                              ) : (
                                <Tooltip
                                  title={!expand ? `${subItem?.navName}` : ''}
                                >
                                  {(() => {
                                    const IconComponent =
                                      iconComponents[subItem?.navName];
                                    const selectedIcon =
                                      selectedIcons[subItem?.navName];

                                    const color = subItem?.selected
                                      ? 'white'
                                      : hoveredNav === subItem?.navName
                                      ? 'var(--textBlack)'
                                      : '#616874';

                                    if (selectedIcon && subItem?.selected) {
                                      return <img src={selectedIcon} alt="" />;
                                    }

                                    if (IconComponent) {
                                      return <IconComponent color={color} />;
                                    }
                                    return null;
                                  })()}
                                </Tooltip>
                              )}
                              <span
                                className={` ${
                                  expand ? 'expand-block' : 'expand-hidden'
                                }`}
                              >
                                {subItem?.navName}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {canScrollDown && (
            <div
              className="absolute bottom-0 left-0 right-0 z-[11] flex items-center justify-center cursor-pointer py-1 transition-all duration-300 hover:opacity-100 opacity-70"
              style={{
                background:
                  'linear-gradient(to top, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.4) 60%, transparent 100%)',
                color: '#757d8bff',
              }}
              onClick={() => handleArrowScroll('down')}
            >
              <ArrowDownOutlined className="text-sm" />
            </div>
          )}
        </div>
      </div>
      <div className="">
        {/* Bottom Section: Plan Details + Credits + My Profile */}
        <div className="flex-column pl-10 pt-20">
          {location?.pathname?.startsWith('/user') &&
            planDetails &&
            (() => {
              const planInfo = getPlanInfo();
              const planName = getPlanDisplayName();
              const brandRole = currentUser?.active_accounts
                ?.find((acc) => acc.account_id === currentAccount?.account_id)
                ?.brands?.find(
                  (brand) => brand.brand_id === currentBrand?.brand_id,
                )?.role;

              const showUpgrade =
                planDetails.plan_code !== 'magnum' &&
                (currentAccount?.role === 'Account Owner' ||
                  currentAccount?.role === 'Account Manager' ||
                  brandRole === 'Brand Manager');

              if (!planInfo) return null;

              return (
                <>
                  {expand && (
                    <div className="bg-white border border-[#E8E8EA] rounded-lg p-3 mb-2 min-w-max">
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex flex-col">
                          <span className="text-sm font-semibold text-[#202421]">
                            {planName} Plan
                          </span>
                          {planInfo.type === 'trial' && (
                            <span className="text-xs text-[#616874]">
                              Free trial
                            </span>
                          )}
                        </div>
                        {/* <span className="text-xs text-[#616874]">
                      {planInfo.daysLeft} {planInfo.daysLeft === 1 ? 'day' : 'days'} left
                    </span> */}
                      </div>
                      <p className="text-xs text-[#616874] mb-2">
                        Expires: {planInfo.expiryDate}
                      </p>
                      {showUpgrade && (
                        <button
                          className={`w-full py-2 ${
                            planInfo.daysLeft < 5
                              ? 'bg-[#EF4444] hover:bg-[#DC2626]'
                              : 'bg-[#0F9960] hover:bg-[#0D8550]'
                          } text-white text-xs font-semibold rounded-md transition-colors`}
                          onClick={() =>
                            planInfo.daysLeft < 5
                              ? handleRenewSubscription()
                              : setIsPricingModalOpen(true)
                          }
                        >
                          {planInfo.daysLeft < 5 ? (
                            'Renew'
                          ) : (
                            <div className="flex items-center justify-center gap-2">
                              <UpgradeIcon
                                width={14}
                                height={14}
                                fill="white"
                              />
                              Upgrade
                            </div>
                          )}
                        </button>
                      )}
                    </div>
                  )}
                </>
              );
            })()}

          {location?.pathname?.startsWith('/user') && (
            <>
              {expand && credits?.total_amount < 100 && (
                <span className="text-white font12px-500 bg-[#FF543E] border-[#FF543E]  rounded-tr-xl rounded-tl-xl p-5 w-70">
                  {credits?.total_amount < 100 && credits?.total_amount !== 0
                    ? 'Credits running low!'
                    : credits?.total_amount === 0
                    ? 'Credits exhausted'
                    : ''}
                </span>
              )}
              <Tooltip
                title={
                  credits?.total_amount > 100 ? (
                    <>
                      {credits?.currency_symbol} {credits?.total_amount} Credits
                      left
                    </>
                  ) : (
                    (() => {
                      const planInfo = getPlanInfo();
                      if (!planInfo?.isExpired) {
                        return 'Click here to purchase';
                      }
                      return '';
                    })()
                  )
                }
                className="w-100"
              >
                <div
                  className={`mb-20 flex-row align-center  gap-2 border border-[var(--border-input)] b-radius-6 prl-10 py-2 text-[var(--font-600)] pointer min-w-max ${
                    !expand ? 'justify-center' : ''
                  }`}
                  onClick={() => {
                    const planInfo = getPlanInfo();
                    if (!planInfo?.isExpired) {
                      setAddCredits(true);
                    }
                  }}
                >
                  {!expand && (
                    <img src={ICONSS?.creditsSideBar} alt="creditsSideBar" />
                  )}
                  {expand && (
                    <>
                      <span className="font14px-600">
                        {credits?.currency_symbol}{' '}
                        {(credits?.total_amount &&
                          // formatNumber(credits?.total_amount))
                          credits?.total_amount) ||
                          '0.00'}
                      </span>
                      <span className="font14px-400">Credits</span>
                    </>
                  )}
                </div>
              </Tooltip>
            </>
          )}
          <Popover
            open={isPopover}
            onOpenChange={(open) => setIsPopover(open)}
            trigger={'click'}
            arrow={false}
            content={
              <div className="w-[280px] bg-white rounded-xl overflow-hidden shadow-lg border border-[#F1F4F6]">
                {/* User Info Header */}
                <div className="p-4 bg-[#F9FAFB] border-bottom border-[#F1F4F6]">
                  <div className="flex items-center gap-3">
                    <div className="flex-shrink-0 size-10 rounded-full overflow-hidden border-2 border-white shadow-sm">
                      {currentUser?.profile_photo ? (
                        <img
                          src={currentUser?.profile_photo}
                          alt="profile"
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <img
                          src={ICONSS?.profileBoy}
                          alt="profile"
                          className="w-full h-full object-cover opacity-80"
                        />
                      )}
                    </div>
                    <div className="flex flex-col min-w-0">
                      <span className="text-sm font-semibold text-[#111827] truncate">
                        {currentUser?.full_name}
                      </span>
                      <Tooltip title={currentUser?.email}>
                        <span className="text-xs text-[#6B7280] truncate">
                          {currentUser?.email}
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                </div>

                {/* Actions Section */}
                <div className="p-1.5">
                  {pathname.startsWith('/user') &&
                    (currentAccount?.role === 'Account Owner' ||
                      currentAccount?.role === 'Account Manager') &&
                    planDetails?.plan_code !== 'magnum' && (
                      <>
                        <div
                          className="group flex items-center gap-3 px-3 py-2.5 rounded-lg border border-transparent hover:border-[#E5E7EB] hover:bg-[#F9FAFB] transition-all duration-200 cursor-pointer mb-1"
                          onClick={() => {
                            setIsPricingModalOpen(true);
                            setIsPopover(false);
                          }}
                        >
                          <div className="size-8 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
                            <UpgradeIcon
                              width={16}
                              height={16}
                              fill="#0F9960"
                            />
                          </div>
                          <span className="text-[14px] font-medium text-[#0F9960]">
                            Upgrade Plan
                          </span>
                        </div>
                        <div className="h-px bg-[#F1F4F6] mx-2 my-1.5" />
                      </>
                    )}

                  {myProfile?.map((item) => (
                    <div
                      key={item?.id}
                      className="group flex items-center gap-3 px-3 py-2.5 rounded-lg border border-transparent hover:bg-[#FEF2F2] transition-all duration-200 cursor-pointer"
                      onClick={() => {
                        if (item?.id === 4) {
                          handleItemClick(item);
                        }
                      }}
                    >
                      <div className="size-8 rounded-lg bg-[#FEF2F2]-- flex items-center justify-center --group-hover:bg-[#FEE2E2] transition-colors duration-200">
                        <img
                          src={item?.icon}
                          alt={item?.label}
                          className="size-4 opacity-80 group-hover:opacity-100"
                        />
                      </div>
                      <span className="text-[14px] font-medium text-[#EF4444] group-hover:text-[#DC2626] transition-colors duration-200">
                        {item?.label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            }
            overlayClassName="my-profile-popover"
            zIndex={1051}
          >
            <div className="w-90 flex-row align-center space-between pointer">
              <div className="flex-row align-center">
                <div className="size-[2.18vw] rounded-full flex items-center justify-center font-largest weight-medium">
                  {/* <Avatar color="#ffffff" /> */}
                  {currentUser?.profile_photo ? (
                    <img
                      src={currentUser?.profile_photo}
                      alt="profileBoy"
                      className="w-[2.2vw] object-cover rounded-full"
                    />
                  ) : (
                    <img src={ICONSS?.profileBoy} alt="profileBoy" />
                  )}
                </div>
                {expand && (
                  <span className="navName text-[var(--textBlack)] pl-10">
                    My Profile
                  </span>
                )}
              </div>
              {expand && (
                <Chevron
                  color={'var(--font-600)'}
                  strokeColor={'var(--font-600)'}
                />
              )}
            </div>
          </Popover>
        </div>
      </div>

      <Modal
        styles={{ content: { padding: 0 } }}
        open={isModalVisible}
        setOpen={setIsModalVisible}
        className={'asp-modal-popup-small'}
        closable={false}
        centered={true}
        wrapClassName={'bg-[#00000095]'}
        footer={false}
        zIndex={1052}
      >
        <NewAlert
          handleCancel={handleCancel}
          open={isModalVisible}
          setOpen={() => setIsModalVisible(true)}
          handleNo={() => setIsModalVisible(false)}
          handleYes={handleYes}
          icon={ICONS?.logout}
          content={<p>Are you sure you want to Logout ?</p>}
          title={'Log out, really'}
          noName="Yes, logout"
          buttonColor="var(--new-primary)"
          yesName=" No, I'll stay"
          noButtonClassName="!font-md !weight-semibold"
          loading={loader}
          yesButtonClassName="py-[0.25vw]"
        />
      </Modal>

      <Modal
        styles={{ content: { padding: 0 } }}
        footer={null}
        open={discardAlertOpen}
        className={'asp-modal-popup-small'}
        closable={false}
        centered={true}
        wrapClassName={'bg-[#00000095]'}
      >
        <NewAlert
          type="new"
          open={discardAlertOpen}
          icon={ICONS?.AlertIcon}
          setOpen={setDiscardAlertOpen}
          content={
            <div>
              <p>
                You have made some changes in the template. How would you like
                to proceed.
              </p>
            </div>
          }
          noName="Continue Editing"
          yesName="Discard"
          noButtonClassName="!font-md !weight-semibold"
          handleNo={() => {
            discardCarousel();
          }}
          handleYes={() => {
            setDiscardAlertOpen(false);
          }}
        />
      </Modal>
      <Modal
        styles={{ content: { padding: 0 } }}
        footer={null}
        open={draftAlertOpen}
        className={'asp-modal-popup-small'}
        closable={false}
        centered={true}
        wrapClassName={'bg-[#00000095]'}
      >
        <NewAlert
          type="new"
          open={draftAlertOpen}
          icon={ICONS?.AlertIcon}
          setOpen={setDraftAlertOpen}
          content={
            <div>
              <p>What would you like to do with the broadcast?</p>
            </div>
          }
          noName="Continue Editing"
          yesName="Draft"
          noButtonClassName="!font-md !weight-semibold"
          handleNo={() => {
            discardCarousel(header);
          }}
          handleYes={() => {
            setDraftAlertOpen(false);
          }}
        />
      </Modal>

      {/* Expiration Modal */}
      <Modal
        styles={{
          content: { padding: 0 },
          mask: {
            left: expand ? '13%' : '5%',
            width: expand ? '87%' : '95%',
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
          },
        }}
        open={subscriptionExpiredPopover}
        footer={null}
        className="asp-modal-popup-medium"
        closable={false}
        centered
        mask
        maskClosable={false}
        zIndex={1002}
        destroyOnHidden
        style={{
          width: '100%',
          borderRadius: 20,
          boxShadow: '0px 10px 24px 0px rgba(79, 92, 128, 0.15)',
          overflow: 'hidden',
        }}
      >
        <div className="px-10 py-10 text-center flex flex-col items-center">
          <div className="w-16 h-16 rounded-full bg-[#FEF2F2] flex items-center justify-center mb-6">
            <svg
              width="6"
              height="26"
              viewBox="0 0 6 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="6" height="18" rx="3" fill="#EF4444" />
              <rect y="20" width="6" height="6" rx="3" fill="#EF4444" />
            </svg>
          </div>

          <h2 className="text-[24px] font-[700] text-[#111827] mb-3">
            Your subscription has ended
          </h2>
          <p className="text-[#6B7280] font-[400] text-[15px] leading-6 max-w-[400px]">
            Your plan has expired and access to premium features is paused.
            Renew your subscription to continue without interruption.
          </p>

          <div className="w-full flex flex-col gap-3 mt-8 max-w-[320px]">
            <button
              className="w-full h-11 rounded-md bg-[#0F9960] hover:bg-[#059669] text-white text-[15px] font-semibold transition-colors duration-200 flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
              onClick={() => {
                handleRenewSubscription();
              }}
              disabled={loader}
            >
              {loader ? (
                <>
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{ fontSize: 18, color: 'white' }}
                        spin
                      />
                    }
                  />
                  Processing...
                </>
              ) : (
                'Renew subscription'
              )}
            </button>

            <button
              className="w-full text-[#6B7280] hover:text-[#374151] text-[15px] font-medium transition-colors duration-200"
              onClick={() => setIsPricingModalOpen(true)}
            >
              View plans
            </button>
          </div>

          <p className="mt-8 text-[14px] text-[#6B7280] italic">
            For inquiries, mail us at{' '}
            <span className="font-bold text-[#6940F2] not-italic">
              support@gainwix.ai.
            </span>
          </p>
        </div>
      </Modal>

      <CheckoutModal
        open={proceed}
        setOpen={setProceed}
        isPlanSelected={isPlanSelected}
        handleBackPlan={() => {
          // For credits, we would cancel the transaction here
          // For now, just close the modal
          setProceed(false);
        }}
        locationError={locationError}
        brandsData={brandsData}
        creditsResponse={creditsResponse}
        dynamicInputs={dynamicInputs}
        editInfo={editInfo}
        setEditInfo={setEditInfo}
        handleUpdate={handleUpdate}
        handleBrandChange={handleBrandChange}
        input={input}
        inputContainer={inputContainer}
        buttonClass={buttonClass}
        category={category}
        stateList={stateList}
        cityList={cityList}
        buttonEnable={buttonEnable}
        handlePayment={handlePayment}
        currentAccount={currentAccount}
      />

      {/* Pricing Plan Modal for both Upgrades and View Plans */}
      <PricingPlanModal
        open={isPricingModalOpen}
        setOpen={setIsPricingModalOpen}
        brandId={currentBrand?.brand_id}
        brandsData={currentBrand}
        currentAccount={currentAccount}
        onSuccess={() => {
          // Close the expiration modal if it was open
          setSubscriptionExpiredPopover(false);

          // Refresh current user data after successful upgrade
          currentUserDetails().then((res) => {
            if (res?.status === 200) {
              dispatch(updateCurrentUser(res?.data?.data));
            }
          });

          // Refresh credits and plan details
          creditsApi(currentBrand?.brand_id).then((res) => {
            if (res?.status === 200) {
              setCredits(res?.data?.brand_credits);
              setPlanDetails(res?.data?.plan_details);
            }
          });
        }}
      />

      {/* Buy Credits Modal */}
      <Modal
        styles={{ content: { padding: 0 } }}
        open={addCredits}
        footer={null}
        closable={false}
        centered={true}
        wrapClassName={'bg-[#00000095]'}
        width={'45%'}
      >
        <div className="flex-row align-center space-between p-20">
          <div className="flex-row align-center gap-2">
            <img src={ICONSS?.conversationCredits} alt="conversationCredits" />
            <span className="font22px-600 text-[var(--textBlack)]">
              WhatsApp Conversation Credits
            </span>
          </div>
          <div
            onClick={() => {
              setCreditValue('');
              setAddCredits(false);
              setLocationError('');
            }}
            onMouseOver={() => setCloseHover(true)}
            onMouseOut={() => setCloseHover(false)}
            className="pointer"
          >
            <Popup
              color={!closeHover ? 'var(--textBlack)' : '#FF543E'}
              fill={!closeHover ? '#F1F4F6' : '#FFE3E0'}
            />
          </div>
        </div>

        <div className="pl-20 pb-20">
          <span className="font15px-500 text-[var(--textBlack)]">
            Hey, do you send out broadcasts to your contacts? You should add
            some more credits!
          </span>
          <div className="pr-20 ptb-20">
            <div className="flex-row align-center border border-[#E8E8EA] p-5 b-radius-6">
              <p className="flex-row border-r-[1px] pl-10 pr-[12px] font14px-600 text-[var(--font-600)]">
                {brandsData?.brand_currency_code}
                {/* <img
                  src={ICONS?.dropDownIcon}
                  alt="dropDownIcon"
                  className="w-4 pl-5"
                /> */}
              </p>
              <div className="w-100 pl-10 font14px-500 text-[var(--textBlack)]">
                <input
                  onChange={handleCreditValue}
                  value={creditValue}
                  placeholder={`Minimum ${brandsData?.brand_currency_symbol} ${brandsData?.credit_purchase_amount?.[0]} credits required.`}
                  className="w-100"
                />
              </div>
            </div>
            {locationError && (
              <div className="flex-row align-center pt-5">
                <img src={ICONS?.alertIconError} alt="" />
                <span className="capitalize error-message pl-5">
                  {locationError}
                </span>
              </div>
            )}
            <div className="w-80 flex-row align-center mt-20 pb-20 space-between">
              {brandsData?.credit_purchase_amount?.map((amount, index) => (
                <span
                  key={index}
                  className="gap-2 bg-[#EDEFF1] py-1 px-5 b-radius-6 pointer"
                  onClick={() =>
                    handleCreditClick({ id: index + 1, label: `+ ${amount}` })
                  }
                >
                  + {brandsData?.brand_currency_symbol} {amount}
                </span>
              ))}
            </div>
            <div className="w-100 flex-row justify-end">
              {creditValue >= brandsData?.credit_purchase_amount?.[0] ? (
                <button
                  className="button-primary pointer text-[var(--font-600)] border border-[#E8E8EA] px-10 py-1 b-radius-6"
                  onClick={handleCreditSend}
                  disabled={loader}
                >
                  {loader ? (
                    <div
                      className="flex-row align-center justify-center"
                      style={{ width: '70px', height: '18px' }}
                    >
                      <Loader
                        Width={20}
                        Height={20}
                        loaderColor="white"
                        loaderBg="rgba(255, 255, 255, 0.3)"
                      />
                    </div>
                  ) : (
                    'Buy Now'
                  )}
                </button>
              ) : (
                <button className="text-[var(--font-600)] border border-[#E8E8EA] px-10 py-1 b-radius-6 cursor-not-allowed">
                  Buy Now
                </button>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </nav>
  );
}

export default SideBar;
